export default {seo:{title:'Account Settings',description:null},title:'Settings'};